<template>
  <div
    v-click-outside="dropdownClose"
    class="ws-state-drop-down-radio-001"
  >
    <p
      v-if="title"
      class="dropdown-menu-button_title"
    >
      {{ title }}<span v-if="required">*</span>
    </p>
    <ValidationProvider
      v-slot="{ errors }"
      :rules="rules"
      class="dropdown-wrap"
    >
      <div class="dropdown-menu-button_content-wrap">
        <p
          v-if="beforeText"
          class="text"
        >
          {{ beforeText }}
        </p>
        <div
          class="dropdown-menu-button_content"
          :class="{outline: outline, widthFix180: widthFix180,widthFix200:widthFix200,disabled:disabled,error:errors.length>0}"
        >
          <i
            v-if="leadingIcon"
            class="icon leading-icon"
            :class="leadingIcon"
          />
          <button
            :class="{select:value}"
            @click="onclick()"
          >
            {{ computedButtonTextLabel }}
          </button>
          <i
            v-if="outline"
            class="icon trailing-icon outline icon-chevron-up"
            :class="{show: dropdown_menu_show}"
          />
          <i
            v-if="disabled"
            class="icon trailing-icon icon-chevron-down"
          />
          <i
            v-else-if="!outline && !dropdown_menu_show"
            class="icon trailing-icon icon-arrow-drop-down-circle"
          />
          <i
            v-else-if="!outline && dropdown_menu_show"
            class="icon trailing-icon icon-arrow-drop-up-circle"
          />
          <transition mode="out-in">
            <div
              v-if="dropdown_menu_show"
              class="dropdown-menu"
            >
              <perfect-scrollbar class="ps dropdown-scrollable-content">
                <div
                  v-for="(item,item_k) in dropdownMenuItem"
                  :key="item_k"
                  class="dropdown-menu-item"
                  :class="{selected:selectedItem(item)}"
                  @click="selectMenuItem(item)"
                >
                  {{ $t(item.textLabel) }}
                </div>
              </perfect-scrollbar>
            </div>
          </transition>
        </div>
        <p
          v-if="afterText"
          class="text"
        >
          {{ afterText }}
        </p>
        <input
          type="hidden"
          :value="value"
        >
      </div>
      <div
        v-if="errors.length > 0"
        class="invalid-text"
      >
        <i class="icon-warning invalid-icon" />
        <p
          v-for="(text_e,text_k) in errors"
          :key="text_k"
          class="text"
        >
          {{ text_e }}
        </p>
      </div>
      <div
        v-if="remindText && !errors.length > 0"
        class="remind-text"
      >
        <i class="icon-warning" />
        <p>{{ $t(remindText) }}</p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "WsStateDropdownRadio001",
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    dropdownMenuItem: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    widthFix180: {
      type: Boolean,
      default: false,
    },
    widthFix200: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    remindText: {
      type: String,
      default: "",
    },
    beforeText: {
      type: String,
      default: "",
    },
    afterText: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    dropdown_menu_show: false,
    templateContent: null,
  }),
  computed: {
    computedButtonTextLabel() {
      if (this.dropdownMenuItem.length === 0) return;
      if (this.value) {
        let selectedItem = this.value;
        let num = this.selectedItemNum(selectedItem);
        let selectedItemTextLabel = this.dropdownMenuItem[num];
        return selectedItemTextLabel.textLabel;
      }
      let placeholder = this.placeholder;
      if (placeholder) return placeholder;
      return this.dropdownMenuItem[0].textLabel;
    },
  },
  methods: {
    onclick() {
      if (this.disabled) {
        return;
      }
      this.toggleDropdownMenuShow();
    },
    toggleDropdownMenuShow() {
      this.dropdown_menu_show = !this.dropdown_menu_show;
    },
    selectMenuItem(item) {
      // this.placeholder = item.textLabel;
      this.$emit("input", item.id);
      this.dropdown_menu_show = false;
      this.$emit("click", item.id);
    },
    selectedItem(item) {
      if (this.value == item.id) {
        return true;
      } else {
        return false;
      }
    },
    dropdownClose() {
      this.dropdown_menu_show = false;
    },
    selectedItemNum(select) {
      if (!this.dropdownMenuItem) return;
      if (!select) {
        return;
      }
      let allId = this.dropdownMenuItem.map((item) => {
        return item.id;
      });
      let selectedNum = allId.indexOf(select);
      return selectedNum;
    },
  },
};
</script>